import { BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../assets/scss/pages/RevenueBook.module.scss';

export default function RevenueBookIndex() {
    const navigate = useNavigate();

    return (
        <div className={styles.page}>
            <div className={styles.header}>
                <div>
                    <h1 className={styles.title}>Sổ doanh thu</h1>
                    <p className={styles.subtitle}>Chọn loại sổ doanh thu</p>
                </div>
            </div>

            <div className={styles.indexGrid}>
                <div className={styles.indexCard} onClick={() => navigate('/admin/revenue-book/s1a-hkd')}>
                    <div className={styles.indexCardIcon}><BookOpen /></div>
                    <div className={styles.indexCardTitle}>Sổ doanh thu S1a-HKD</div>
                    <div className={styles.indexCardDesc}>
                        Dành cho hộ kinh doanh có doanh thu dưới 500 triệu/năm.
                        Theo Thông tư 152/2025/TT-BTC ngày 31/12/2025 của Bộ Tài chính.
                    </div>
                </div>
            </div>
        </div>
    );
}
